import {CircleStop, Edit, PlusSquare, StopCircle} from 'lucide-angular';
import {MenuAction} from '@shared/interfaces/header/menu-action';

export const meteringPointMeterMenuAction: MenuAction[] = [
  {
    id: 'createMeter',
    title: 'meteringpoint.meter.create.title',
    icon: PlusSquare,
  },
  {
    id: 'stopMeter',
    title: 'meteringpoint.meter.stop.title',
    icon: StopCircle,
    iconColor: 'text-red-500'
  },
  {
    id: 'createControlMeter',
    title: 'meteringpoint.meter.createcontrolmeter.title',
    icon: PlusSquare,
  },
  {
    id: 'stopControlMeter',
    title: 'meteringpoint.meter.removecontrolmeter.title',
    icon: CircleStop,
    iconColor: 'text-red-500',
    breaker: true,
  },
  {
    id: 'htx',
    title: 'meteringpoint.meter.htx.title',
    icon: Edit,
  }
];
